/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesEmailDesignTemplate = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type WebApiModelsEnumerationTypesEmailDesignTemplate = typeof WebApiModelsEnumerationTypesEmailDesignTemplate[keyof typeof WebApiModelsEnumerationTypesEmailDesignTemplate];


export function WebApiModelsEnumerationTypesEmailDesignTemplateFromJSON(json: any): WebApiModelsEnumerationTypesEmailDesignTemplate {
    return WebApiModelsEnumerationTypesEmailDesignTemplateFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesEmailDesignTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesEmailDesignTemplate {
    return json as WebApiModelsEnumerationTypesEmailDesignTemplate;
}

export function WebApiModelsEnumerationTypesEmailDesignTemplateToJSON(value?: WebApiModelsEnumerationTypesEmailDesignTemplate | null): any {
    return value as any;
}

